require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-specialized-caseload.json") })
        }
      }, "path---tags-specialized-caseload");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-specialized-caseload!./.cache/json/tags-specialized-caseload.json
// module id = 1038
// module chunks = 231608221292675